import React from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import './rotasModule.css'

export default class MinhasRotas extends React.Component {
    constructor(props) {
        super(props)
        this.state = { list: [], loaded: false }
    }

    componentDidMount() {
        axios.post('/api/rota/minhasRotas2', { user: localStorage.nome })
            .then((resp) => this.setState({ list: resp.data, loaded: true }))
            .catch((error) => alert(error.response?.data || 'Erro ao carregar rotas.'))
    }

    render() {
        return (
            <div className="container rota-page">
                <div className="rota-hero">
                    <p className="rota-eyebrow mb-1">Painel do fiscal</p>
                    <h1 className="rota-title mb-2">Minhas rotas</h1>
                    <p className="rota-subtitle mb-0">Acompanhe solicitações abertas, decisões e arquivamentos em um só lugar.</p>
                </div>
                <div className="rota-surface">
                    <div className="table-responsive">
                        <table className="table table-borderless mb-0">
                            <thead><tr><th>Situação</th><th>Estado</th><th>Itens</th><th></th></tr></thead>
                            <tbody>
                                {this.state.loaded && this.state.list.map((rota) => (
                                    <tr key={rota._id}>
                                        <td><span className={`rota-status-pill ${rota.situacao}`}>{rota.situacao}</span></td>
                                        <td>{rota.estado}</td>
                                        <td>{rota.normalized?.analytics?.totalItens || 0}</td>
                                        <td>{rota.situacao === 'aberta' ? null : <Link to={`/arquivaRota/${rota._id}`} target="_blank"><button className="btn rota-secondary-button">Abrir</button></Link>}</td>
                                    </tr>
                                ))}
                                {this.state.loaded && this.state.list.length === 0 && <tr><td colSpan="4" className="text-center rota-muted">Nenhuma rota encontrada.</td></tr>}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}
